export const USERS_TAB = "report_users";
export const ROLES_TAB = "report_roles";
export const PRODUCTS_TAB = "reports_products";
export const GENERATE_OTP_TAB = "generate_otp";
export const HEALTH_STATUS_TAB = "health_status";
export const RETAILER_REPORTS_TAB = "report_retailer";
export const CONFIGURATION_TAB = "configuration";
